import Button from '@elementor/ui/Button';
import Infotip from '@elementor/ui/Infotip';
import { styled } from '@elementor/ui/styles';
import PropTypes from 'prop-types';
import { cloneElement, useState, useCallback, useRef } from 'react';
import BoltStarIcon from '@images/boltstar-icon';
import { __ } from '@utils/i18n';

const FixButton = ({ infoTipContent }) => {
	const [open, setOpen] = useState(false);
	const buttonRef = useRef(null);
	const popperRef = useRef(null);

	const handleOpen = useCallback(() => setOpen(true), []);
	const handleClose = useCallback(() => setOpen(false), []);

	const content = infoTipContent
		? cloneElement(infoTipContent, { onClose: handleClose })
		: null;

	const handleKeyDown = (e) => {
		if (e.key === 'Escape') {
			handleClose();
		}
	};

	const isInsideRefs = (node) => {
		if (!node) {
			return false;
		}
		return (
			(buttonRef.current && buttonRef.current.contains(node)) ||
			(popperRef.current && popperRef.current.contains(node))
		);
	};

	const handleButtonBlur = (e) => {
		const next = e.relatedTarget;
		if (!isInsideRefs(next)) {
			handleClose();
		}
	};

	const handlePopperBlur = (e) => {
		const next = e.relatedTarget;
		if (!isInsideRefs(next)) {
			handleClose();
		}
	};

	return (
		<StyledInfoTip
			tabIndex="0"
			placement="top"
			content={content}
			open={open}
			onClose={handleClose}
			disableHoverListener
			disableFocusListener
			disableTouchListener
			PopperProps={{
				disablePortal: true,
				ref: popperRef,
				onBlur: handlePopperBlur,
				onKeyDown: handleKeyDown,
			}}
		>
			<StyledButton
				ref={buttonRef}
				fullWidth
				size="medium"
				color="info"
				variant="contained"
				startIcon={<BoltStarIcon />}
				onClick={() => setOpen(true)}
				onFocus={handleOpen}
				onBlur={handleButtonBlur}
				onKeyDown={handleKeyDown}
			>
				{__('Fix it with Ally')}
			</StyledButton>
		</StyledInfoTip>
	);
};

const StyledInfoTip = styled(Infotip)`
	.MuiTooltip-tooltip {
		border-radius: ${({ theme }) => theme.shape.borderRadius * 2}px;
	}

	video {
		width: 100%;
		display: block;

		background: linear-gradient(-71deg, #2847f3 26.68%, #17298d 124.48%);
	}
`;

const StyledButton = styled(Button)`
	border-radius: ${({ theme }) => theme.shape.borderRadius * 2}px;

	.MuiSvgIcon-root path {
		fill: ${({ theme }) => theme.palette.common.white};
	}
`;

FixButton.propTypes = {
	infoTipContent: PropTypes.node,
};

export default FixButton;
